import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  chip: {
    "&.MuiChip-root": {
      backgroundColor: "#E6F1FF",
      color: "#000000",
      fontFamily: "Inter",
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
    },
  },
  deleteIcon: {
    color: "#000000",
    width: "16px",
    height: "16px",
  },
}));
